import MinimalTemplate from './MinimalTemplate'
export default MinimalTemplate